import styles from '../../styles/ads.module.scss';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { formatPriceWithCurrency } from '../../utils/formatPrice';
import {formatOrderStatus, formatOrderChannelAsPill, ORDER_STATUSES} from '../../utils/formatOrderStatus';
import {useEffect, useState} from "react";
import FilterDropdown from "../../components/filters/FilterDropdown";
import {Button} from "antd";


const OrderDetailsTable = ({ data, onStatusUpdate }) => {
  const {
    orderNumber,
    date,
    lastEditedAt,
    status,
    subtotal,
    discountLabel,
    totalWithDiscount,
    deliveryFee,
    payment,
    agent,
    channel,
    referralDoctor,
    isMentorPackage,
  } = data;
  const [selectedStatus, setSelectedStatus] = useState(status);
  const [isSaving, setIsSaving] = useState(false);

  const handleStatusChange = (filter) => {
    if (filter.status) {
      setSelectedStatus(filter.status);
    }
  };

  const handleSave = async () => {
    if (selectedStatus === status) {
      return;
    }

    setIsSaving(true);
    try {
      await onStatusUpdate(selectedStatus);
    } catch (error) {
      console.error('Failed to update status:', error);
      setSelectedStatus(status);
    } finally {
      setIsSaving(false);
    }
  };

  const statusSections = [
    {
      type: 'status',
      title: 'Status porudžbine',
      items: ORDER_STATUSES.filter(s => s.key !== 'processing' && s.key !== 'vip'),
    },
  ];

  const hasChanges = selectedStatus !== status;

  useEffect(() => {
    setSelectedStatus(status);
  }, [status]);
  
  const formatUserDisplayName = (user) => {
    return `${user?.firstName} ${user?.lastName}`;
  }

  return (
    <div className="table-wrapper">
      <table
        style={{ width: '100%' }}
        className={`${styles.table} grayTheme mobNoScroll`}
      >
        <thead>
          <tr>
            <th className="customWidthCell customWidthCell__singleOrderDetails">
              Detalji porudžbine
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Broj porudžbine</td>
            <td>
              <span>{orderNumber || '-'}</span>
            </td>
          </tr>
          <tr>
            <td>Ime korisnika</td>
            <td>
              <span>{data.user?.fullName}</span>
            </td>
          </tr>
          <tr>
            <td>Email korisnika</td>
            <td>
              <span>{data.user?.email}</span>
            </td>
          </tr>
          <tr>
            <td>Broj telefona</td>
            <td>
              <span>{data.user?.phone}</span>
            </td>
          </tr>
          <tr>
            <td>Datum porudžbine</td>
            <td>
              <span>{date ? dayjs(date).format('DD.MM.YYYY.') : '-'}</span>
            </td>
          </tr>
          {lastEditedAt && (
            <tr>
              <td>Poslednja izmena</td>
              <td>
                <span>{dayjs(lastEditedAt).format('DD.MM.YYYY. HH:mm')}</span>
              </td>
            </tr>
          )}
          <tr>
            <td>Tip kupovine</td>
            <td>{formatOrderChannelAsPill(channel, referralDoctor, isMentorPackage)}</td>
          </tr>
          <tr>
            <td>Način plaćanja</td>
            <td>
              <span>
                {payment?.method === 'card' ? 'Karticom' : payment?.method === 'cash_on_delivery' ? 'Pouzećem' : payment?.method === 'in_person' ? 'Lično' : '-'}
              </span>
            </td>
          </tr>
          {discountLabel && (
            <tr>
              <td>Popust</td>
              <td>
                <span style={{ color: '#1a7f37', fontWeight: 600 }}>{discountLabel}</span>
              </td>
            </tr>
          )}
          <tr>
            <td>ID Transakcije</td>
            <td>
              <span>{payment?.transaction?.transId || '-'}</span>
            </td>
          </tr>
          {agent && (
            <tr>
              <td>Agent kod</td>
              <td>
                <span>{agent.firstName} {agent.lastName} - {agent.referralCode}</span>
              </td>
            </tr>
          )}
          <tr>
            <td>Status porudžbine</td>
            <td>
              <FilterDropdown
                sections={statusSections}
                selectedFilter={{ status: selectedStatus }}
                onFilterChange={handleStatusChange}
                buttonLabel={formatOrderStatus(selectedStatus)}
                disabled={status === 'processing' || status === 'vip'}
              />
            </td>
          </tr>
          <tr>
            <td>Adresa dostave</td>
            <td>
              <span>{data.shippingAddress?.streetAndNumber || '-'}</span>
            </td>
          </tr>
          <tr>
            <td>Grad</td>
            <td>
              <span>{data.shippingAddress?.city || '-'}</span>
            </td>
          </tr>
          <tr>
            <td>Poštanski broj</td>
            <td>
              <span>{data.shippingAddress?.postalCode || '-'}</span>
            </td>
          </tr>
          {deliveryFee != null && (
            <tr>
              <td>Dostava</td>
              <td>
                {deliveryFee === 'free' ? (
                  <span style={{ color: '#1a7f37', fontWeight: '600' }}>
                    Besplatna
                  </span>
                ) : (
                  `${Number(deliveryFee).toLocaleString('sr-RS')}`
                )}
              </td>
            </tr>
          )}
          <tr>
            <td>Međuiznos</td>
            <td>
              <span>{formatPriceWithCurrency(subtotal || 0)}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span style={{ fontWeight: '700' }}>
                Ukupna cena
                <br />
                sa uračunatim popustom <br /> i sabranom cenom dostave
              </span>
            </td>
            <td>
              <span style={{ fontWeight: '700' }}>
                {formatPriceWithCurrency(totalWithDiscount || 0)}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      {hasChanges && (
        <div
          style={{
            marginTop: '20px',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Button
            type="primary"
            className={`btn-primary `}
            onClick={handleSave}
            loading={isSaving}
            disabled={isSaving}
          >
            Sačuvaj izmene
          </Button>
        </div>
      )}
    </div>
  );
};
export default OrderDetailsTable;

OrderDetailsTable.propTypes = {
  data: PropTypes.shape({
    orderNumber: PropTypes.string,
    date: PropTypes.string,
    lastEditedAt: PropTypes.string,
    status: PropTypes.string,
    subtotal: PropTypes.number,
    discountLabel: PropTypes.string,
    totalWithDiscount: PropTypes.number,
    deliveryFee: PropTypes.bool,
    channel: PropTypes.oneOf(['mobile', 'web']),
    referralDoctor: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      referralCode: PropTypes.string,
    }),
    shippingAddress: PropTypes.shape({
      streetAndNumber: PropTypes.string,
      city: PropTypes.string,
      postalCode: PropTypes.string,
    }),
  }).isRequired,
  onStatusUpdate: PropTypes.func.isRequired,
};

OrderDetailsTable.defaultProps = {
  data: {
    date: '',
    status: '',
    subtotal: 0,
    discountLabel: '',
    totalWithDiscount: 0,
    deliveryFee: false,
  },
};
